import React, {Component} from 'react';
import LoadingOverlay from './LoadingOverlay';
import classNames from 'classnames';

function LoadingOverlayWrapper(ComposedComponent) {
    return class extends Component {
        render() {
            const {loading, className, ...rest} = this.props;
            const status = loading ? 'status' : '';
            const composeComponentClasses = classNames(
                {
                    'position-relative': loading
                },
                className
            );

            return (
                <ComposedComponent
                    className={composeComponentClasses}
                    role={status}
                    aria-hidden={loading}
                    {...rest}
                >
                    <LoadingOverlay loading={loading} />
                </ComposedComponent>
            );
        }
    };
}

export default LoadingOverlayWrapper;
